import type React from 'react';
import { type ReactNode, createContext, useContext, useState } from 'react';

export const ApiErrorType = [
  'UNAUTHORIZED',
  'AGREEMENT_REQUIRED',
  'USER_ENROLLMENT_NOT_SELECTED',
  'CSRF_TOKEN_INVALID',
  'NETWORK_ERROR',
  'NOT_FOUND',
  'MAINTENANCE',
  'UNKNOWN',
] as const;

export interface ApiError {
  errorType: (typeof ApiErrorType)[number];
  message: string;
}

type ApiErrorContextProps = {
  apiError: ApiError | null;
  setApiError: (error: ApiError | null) => void;
};

const ApiErrorContext = createContext<ApiErrorContextProps | undefined>(
  undefined,
);

export const useApiError = (): ApiErrorContextProps => {
  const context = useContext(ApiErrorContext);
  if (context === undefined) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

interface ApiErrorProviderProps {
  children: ReactNode;
}

export const ApiErrorProvider: React.FC<ApiErrorProviderProps> = ({
  children,
}) => {
  const [apiError, setApiError] = useState<ApiError | null>(null);

  return (
    <ApiErrorContext.Provider value={{ apiError, setApiError }}>
      {children}
    </ApiErrorContext.Provider>
  );
};
